import { makeGetString } from '../../helpers/_main.js'
import axios from 'axios';

export default {
    doGet(vuex, payload){
        return new Promise((resolve, reject) => {
            let action = payload.action
            let data = payload.data
            let get_params_string = makeGetString(data);
            let endpoint = payload.endpoint ? payload.endpoint : 'ajax';
            let url = encodeURI(window.location.origin + '/' + endpoint + '/' + action + '/' + get_params_string)

            return axios.get(url)
            .then(response => {
                var res = response.data
                resolve(res)
            })
            .catch(error => {
                console.log('errorrr')
                reject(error)
            });
        })
    }
}

export const doPost = (payload) => {

    return new Promise((resolve, reject) => {
        let action = payload.action
        let controller = payload.controller
        let data = payload.data
        let get_params_string = makeGetString(data);
        let url = encodeURI(window.location.origin + '/api/' + controller +'/'+ action + '/' + get_params_string)
        return axios({
            method: 'get',
            url: url,
            //data: data,
            //config: {headers: {'Content-Type': 'multipart/form-data'}}
        })

        .then(response => {
            var res = response.data
            resolve(res)
        })
        .catch(error => {
            console.log('error')
            reject(error)
        });
    })
};

export const doGet = (payload) => {
    return new Promise((resolve, reject) => {
        let action = payload.action
        let data = payload.data
        let get_params_string = makeGetString(data);
        let endpoint = payload.endpoint ? payload.endpoint : 'ajax';
        let url = encodeURI(window.location.origin + '/' + endpoint + '/' + action + '/' + get_params_string)

        return axios.get(url)
        .then(response => {
            var res = response.data
            resolve(res)
        })
        .catch(error => {
            console.log('errorrr')
            reject(error)
        });
    })
}



// WEBPACK FOOTER //
// ./assets/js/vue/store/actions/axiosActions.js